import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import useModulePermissions from "../../../hooks/useModulePermissions.jsx";
import { Form, Input } from "antd";
import { GetUserNameByTerminalIdAdpi, AddAccountToAccountApi } from "../../../api/request/credit";
import LoadableButton from "../../../components/buttons/LoadableButton";
import ModalComponent from "../../../components/global/modal/ModalComponent";

const { Search } = Input;

const AcToAc = () => {
    const walletPermissions = useModulePermissions('wallet');
    const canCreate = !!walletPermissions.create;
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTransactionLoading, setIsTransactionLoading] = useState(false);
    const [fromLoading, setFromLoading] = useState(false);
    const [fromAccount, setFromAccount] = useState(null);
    const [toLoading, setToLoading] = useState(false);
    const [toAccount, setToAccount] = useState(null);


    useEffect(() => {
        if (!isModalOpen) {
            form.resetFields();
            setFromAccount(null);
            setToAccount(null);
        }
    }, [isModalOpen]);

    const handleFromAccountSearch = async (terminalId) => {
        try {
            setFromLoading(true);
            const { data } = await GetUserNameByTerminalIdAdpi(terminalId);
            if (data?.success) setFromAccount({ ...data?.data, terminalId });
        } catch (error) {
            toast.error(error?.response?.data?.message);
            form.resetFields();
        } finally {
            setFromLoading(false);
        }
    };

    const handleToAccountSearch = async (terminalId) => {
        try {
            setToLoading(true);
            const { data } = await GetUserNameByTerminalIdAdpi(terminalId);
            if (data?.success) setToAccount({ ...data?.data, terminalId });
        } catch (error) {
            toast.error(error?.response?.data?.message);
            form.resetFields();
        } finally {
            setToLoading(false);
        }
    };

    const handleSubmit = async (value) => {
        try {
            setIsTransactionLoading(true);
            const params = {
                from: Number(value?.from),
                to: Number(value?.to),
                amount: Number(value?.amount),
                comment: value?.comment || "",
            }
            const { data } = await AddAccountToAccountApi(params);
            if (data?.success) {
                toast.success(data?.message)
                setIsModalOpen(false);
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsTransactionLoading(false);
        }
    }

    return (
        <div>
            {/* <div className="flex flex-col sm:flex-row sm:justify-end">
                <div className="flex">
                    {!isSalesManager && (
                        <button onClick={() => setIsModalOpen(true)} className="export-btm flex bg-primary text-sm text-white font-medium uppercase px-9 py-2 rounded-lg themeHover  duration-400" size="large" >
                            <img src="assets/icons/add_icon.svg" alt="icon" className="mr-2" width={15} />
                            New Transaction
                        </button>
                    )}
                </div>
            </div> */}

            <ModalComponent width={600} isOpen={isModalOpen} setIsOpen={setIsModalOpen} title={<div className="font-bold text-lg">New Transaction</div>} onCancel={() => setIsModalOpen(false)}>
                <Form className="w-full flex flex-col justify-center gap-3" autoComplete="off" form={form} onFinish={handleSubmit}>
                    <div className="grid sm:grid-cols-2 gap-3">
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">From Account</label>
                            <Form.Item name="from" rules={[{ required: true, message: "Please enter account number" }]}>
                                <Search placeholder="Search account" enterButton="Search" size="large" loading={fromLoading}
                                    onSearch={handleFromAccountSearch} />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">To Account</label>
                            <Form.Item name="to" rules={[
                                { required: true, message: "Please enter account number" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("from") !== value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error("Account numbers cannot be the same")
                                        );
                                    },
                                }),
                            ]}>
                                <Search placeholder="Search account" enterButton="Search" size="large" loading={toLoading}
                                    onSearch={handleToAccountSearch} />
                            </Form.Item>
                        </div>
                    </div>

                    {fromAccount || toAccount ? (
                        <div className="grid sm:grid-cols-2 gap-3">
                            {fromAccount?.fullName ? (
                                <div className="flex flex-col gap-1 text-base text-[#2F2B3DCC] font-medium">
                                    <p>Name: {fromAccount?.fullName}</p>
                                    <p>Balance: {fromAccount?.balance}</p>
                                </div>
                            ) : null}

                            {toAccount?.fullName ? (
                                <div className="flex flex-col gap-1 text-base text-[#2F2B3DCC] font-medium">
                                    <p>Name: {toAccount?.fullName}</p>
                                    <p>Balance: {toAccount?.balance}</p>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                    <div className="grid sm:grid-cols-2 gap-3">
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Amount</label>
                            <Form.Item name="amount" rules={[
                                { required: true, message: "Please enter amount" },
                                { pattern: /^\d+(\.\d{1,2})?$/, message: "Please enter a valid number" },
                            ]} >
                                <Input stringMode={false} placeholder="Enter amount" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                        <div className="input-white">
                            <label className="text-base text-[#2F2B3DCC] font-medium">Comment</label>
                            <Form.Item name="comment">
                                <Input placeholder="Enter comment" className="mt-1 w-full py-2" />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="flex justify-end mt-8">
                        <LoadableButton
                            className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
                            type="Submit"
                            lable="Add"
                            isLoading={isTransactionLoading}
                            loadingLable="Adding..."
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}

export default AcToAc